module.exports = __webpack_public_path__ + "img/empty_order.4703f1a9.png";